import type { PublicationStatus } from '../types';

const STATUS_STYLES: Record<PublicationStatus, string> = {
  'Uncategorized': 'bg-slate-200 text-slate-700',
  'Ideation': 'bg-gray-200 text-gray-800',
  'In Progress': 'bg-blue-200 text-blue-900',
  'To Review': 'bg-amber-200 text-amber-900',
  'Approuved': 'bg-teal-200 text-teal-900',
  'Scheduled': 'bg-violet-200 text-violet-900',
  'Published': 'bg-emerald-200 text-emerald-900',
};

export function PublicationStatusBadge({ status }: { status: PublicationStatus }) {
  return (
    <span className={`inline-flex px-2 py-0.5 text-[11px] font-medium rounded ${STATUS_STYLES[status] ?? 'bg-gray-200 text-gray-800'}`}>
      {status}
    </span>
  );
}
